'use client';

import { Box, Link, Stack, Typography } from '@mui/material';

import { Iconify, APP_ICONS } from 'src/components/iconify';

import { PolicyTabLoyout } from '../../components/policy-tab-layout';

export const PrivacyView = () => {
  console.log();
  return (
    <PolicyTabLoyout>
      <Stack spacing={3}>
        <Stack>
          <Typography variant="h4">CHÍNH SÁCH BẢO MẬT</Typography>
        </Stack>
        <Stack>
          <Typography variant="body2" fontWeight={700}>
            CenterUp áp dụng các tiêu chuẩn và biện pháp bảo mật nghiêm ngặt trong toàn bộ tổ chức.
            Mọi thành viên của chúng tôi đều được đào tạo và cập nhật các giao thức bảo mật mới
            nhất. Chúng tôi thường xuyên trải qua quá trình thử nghiệm, đào tạo và kiểm toán các
            hoạt động và chính sách của mình.
          </Typography>
        </Stack>
        <Stack>
          <Typography variant="body2">
            Chính sách bảo mật này công bố cách thức mà Công ty Cổ phần Ant Edtech Viet Nam (Sau đây
            gọi tắt là “CenterUp” hoặc “Chúng tôi”) thu thập, lưu trữ và xử lý thông tin hoặc dữ
            liệu cá nhân của các khách hàng của mình thông qua các website, sản phẩm, dịch vụ mà
            chúng tôi cung cấp.
          </Typography>
        </Stack>
        <Stack>
          <Typography variant="body2">
            CenterUp cam kết bảo mật những thông tin mang tính riêng tư của khách hàng. Bạn vui lòng
            đọc bản “Chính sách bảo mật thông tin” dưới đây để hiểu hơn những cam kết mà CenterUp
            thực hiện, nhằm tôn trọng và bảo vệ quyền lợi của người truy cập.
          </Typography>
        </Stack>
        <Stack>
          <Typography variant="body2">
            Chính sách bảo mật này nhằm mục đích giải thích chi tiết cho bạn biết về cách thức thu
            thập, sử dụng và chia sẻ thông tin về bạn khi bạn truy cập và sử dụng ứng dụng của chúng
            tôi tại trang web{' '}
            <Link href="https://centerup.vn" target="_blank" rel="noopener">
              CenterUp
            </Link>
            .
          </Typography>
        </Stack>
        <Stack>
          <Typography variant="body2">
            Chính sách này áp dụng cho tất cả các hoạt động diễn ra trên Trang web và bao hàm mọi
            sản phẩm/dịch vụ được cung cấp bởi CenterUp.
          </Typography>
        </Stack>
        <Stack>
          <Typography variant="body2" fontWeight={700}>
            I. THÔNG TIN NHẬN DẠNG CÁ NHÂN
          </Typography>
          <Typography variant="body2">
            Tại CenterUp, chúng tôi tôn trọng quyền riêng tư của bạn và cam kết bảo vệ thông tin cá
            nhân của bạn một cách cẩn trọng. Chúng tôi chỉ thu thập thông tin cần thiết để vận hành
            trang web, cung cấp dịch vụ và cải thiện trải nghiệm của bạn. Việc thu thập thông tin
            diễn ra minh bạch với sự đồng ý và cho phép bạn kiểm soát cách thức sử dụng thông tin
            của mình.
          </Typography>
        </Stack>
        <Stack>
          <Typography variant="body2" fontWeight={700}>
            II. THÔNG TIN NHẬN DẠNG PHI CÁ NHÂN
          </Typography>
          <Typography variant="body2">
            Chúng tôi có thể thu thập thông tin nhận dạng phi cá nhân về bạn mỗi khi bạn tương tác
            với trang web của chúng tôi. Chính sách về thông tin nhận dạng phi cá nhân này có thể
            bao gồm chi tiết như tên của trình duyệt, loại máy tính và thông tin kỹ thuật về bạn.
            Điều này bao gồm thông tin về kết nối với trang web của chúng tôi, chẳng hạn như hệ điều
            hành và nhà cung cấp dịch vụ Internet được sử dụng, cùng với các thông tin tương tự
            khác.
          </Typography>
        </Stack>
        <Stack>
          <Typography variant="body2" fontWeight={700}>
            III. COOKIE TRÌNH DUYỆT WEB
          </Typography>
          <Typography variant="body2">
            Để mang đến trải nghiệm tốt hơn cho bạn, website của chúng tôi có thể sử dụng trình
            duyệt “cookie”. Những tệp tin cookie này được lưu trữ trên ổ cứng của bạn và có mục đích
            làm việc như một hồ sơ lưu trữ, đôi khi để thu thập thông tin về bạn.
          </Typography>
        </Stack>
        <Stack>
          <Typography variant="body2">
            Tuy nhiên, chúng tôi tôn trọng quyền riêng tư của bạn và nếu bạn muốn, bạn có thể thay
            đổi cài đặt trình duyệt để từ chối hoặc nhận cảnh báo khi nhận được cookie. Lưu ý rằng
            việc từ chối cookie có thể làm ảnh hưởng đến một số tính năng trên trang web và chúng có
            thể không hoạt động đúng như mong đợi.
          </Typography>
        </Stack>
        <Stack>
          <Typography variant="body2" fontWeight={700}>
            IV. CÁCH CHÚNG TÔI SỬ DỤNG THÔNG TIN THU THẬP ĐƯỢC
          </Typography>
          <Typography variant="body2">
            Chúng tôi thu thập và sử dụng thông tin cá nhân của bạn với các mục đích sau:
          </Typography>
        </Stack>
        <Stack>
          <Typography variant="body2" fontWeight={700}>
            Để cải thiện dịch vụ khách hàng
          </Typography>
          <Typography variant="body2">
            Chúng tôi sẽ sử dụng các thông tin mà bạn cung cấp để đáp ứng các yêu cầu và nhu cầu hỗ
            trợ khách hàng hiệu quả hơn.
          </Typography>
        </Stack>
        <Stack>
          <Typography variant="body2" fontWeight={700}>
            Để cá nhân hóa trải nghiệm người dùng
          </Typography>
          <Typography variant="body2">
            Chúng tôi sẽ sử dụng thông tin được tổng hợp để hiểu cách Người dùng của chúng tôi sử
            dụng các dịch vụ và tài nguyên trên trang web của chúng tôi, nhằm tạo ra những trải
            nghiệm tốt nhất cho người dùng.
          </Typography>
        </Stack>
        <Stack>
          <Typography variant="body2" fontWeight={700}>
            Để cải thiện trang web của chúng tôi
          </Typography>
          <Typography variant="body2">
            Các phản hồi mà bạn cung cấp sẽ được sử dụng để cải thiện sản phẩm và dịch vụ của chúng
            tôi giúp các dịch vụ trở nên tốt hơn.
          </Typography>
        </Stack>
        <Stack>
          <Typography variant="body2" fontWeight={700}>
            V. TRUY CẬP, CHỈNH SỬA VÀ XOÁ DỮ LIỆU
          </Typography>
          <Typography variant="body2">
            Để đảm bảo sự linh hoạt trong việc tiếp tục sử dụng dịch vụ của chúng tôi trong tương
            lai, chúng tôi sẽ lưu giữ dữ liệu cá nhân liên quan đến các tài khoản không hoạt động
            trong tối đa 24 tháng, tính từ ngày hoạt động cuối cùng trên tài khoản đó.
          </Typography>
        </Stack>
        <Stack>
          <Typography variant="body2">
            Bạn có tài khoản đang hoạt động có quyền truy cập, chỉnh sửa, sửa đổi và xóa thông tin
            cá nhân của mình bất cứ lúc nào thông qua tài khoản cá nhân của mình.
          </Typography>
        </Stack>
        <Stack>
          <Typography variant="body2">
            Bạn không có tài khoản đang hoạt động có thể gửi email đến{' '}
            <Box component="span" sx={{ color: 'primary.main' }}>
              contact@centerup.vn
            </Box>{' '}
            để yêu cầu quyền truy cập, chỉnh sửa hoặc xóa dữ liệu cá nhân của mình.
          </Typography>
        </Stack>
        <Stack>
          <Typography variant="body2">
            Tuy nhiên, chúng tôi có thể từ chối yêu cầu xóa hoặc sửa đổi dữ liệu nếu chúng tôi cần
            dữ liệu đó để bảo vệ quyền lợi hợp pháp của chúng tôi hoặc thực hiện các nghĩa vụ pháp
            lý.
          </Typography>
        </Stack>
        <Stack>
          <Typography variant="body2" fontWeight={700}>
            VI. CÁC QUYỀN KHÁC
          </Typography>
          <Typography variant="body2">
            Ngoài các quyền, chính sách đã đề cập trong phần trước, chúng tôi tôn trọng quyền của
            Người dùng trong việc hạn chế xử lý dữ liệu cá nhân, phản đối việc xử lý dữ liệu và di
            chuyển dữ liệu.
          </Typography>
        </Stack>{' '}
        <Stack>
          <Typography variant="body2">
            Chúng tôi cam kết hợp tác chặt chẽ với Người dùng để đảm bảo việc thực hiện những quyền
            này một cách toàn vẹn và hiệu quả.
          </Typography>
        </Stack>{' '}
        <Stack>
          <Typography variant="body2" fontWeight={700}>
            VII. CÁCH CHÚNG TÔI BẢO VỆ THÔNG TIN CỦA BẠN
          </Typography>
          <Typography variant="body2">
            Chúng tôi đặt sự quan tâm cao vào việc áp dụng các biện pháp thu thập, lưu trữ và xử lý
            dữ liệu một cách cẩn thận và chính xác. Chúng tôi đảm bảo rằng các biện pháp bảo mật
            được thực hiện để ngăn chặn truy cập trái phép, sửa đổi, tiết lộ hoặc phá hủy thông tin
            cá nhân, tên người dùng, mật khẩu và thông tin giao dịch của bạn.
          </Typography>
        </Stack>
        <Stack>
          <Typography variant="body2">
            Chúng tôi sử dụng các công nghệ và quy trình an ninh tiên tiến nhất để bảo vệ dữ liệu
            được lưu trữ trên Trang web của chúng tôi khỏi các rủi ro và mối đe dọa tiềm tàng.
          </Typography>
        </Stack>{' '}
        <Stack>
          <Typography variant="body2" fontWeight={700}>
            VIII. CHIA SẺ THÔNG TIN CÁ NHÂN CỦA BẠN
          </Typography>
          <Typography variant="body2">
            Chúng tôi không chia sẻ thông tin của bạn cho bất kỳ tổ chức bên thứ ba nào ngoài
            Google, Facebook và các cơ quan pháp luật nếu được yêu cầu. Cụ thể:
          </Typography>{' '}
          <Stack direction="row" alignItems="start">
            <Iconify icon={APP_ICONS.status.dot} />
            <Typography variant="body2">
              Google, Facebook, cho mục đích cung cấp, sử dụng và cải thiện các API của họ.
            </Typography>
          </Stack>
          <Stack direction="row" alignItems="start">
            <Iconify icon={APP_ICONS.status.dot} />
            <Typography variant="body2">
              Các cơ quan pháp luật, nếu luật pháp yêu cầu chúng tôi làm như vậy hoặc nếu chúng tôi
              tin tưởng một cách thiện chí rằng việc tiết lộ đó là cần thiết để bảo vệ quyền của
              chúng tôi hoặc quyền của người khác
            </Typography>
          </Stack>
        </Stack>
        <Stack>
          <Typography variant="body2" fontWeight={700}>
            IX. TRANG WEB CỦA BÊN THỨ BA
          </Typography>
          <Typography variant="body2">
            Trên trang web của chúng tôi, bạn có thể gặp phải quảng cáo và nội dung khác, cũng như
            các liên kết đến trang web và dịch vụ của các đối tác, nhà cung cấp, nhà quảng cáo, nhà
            tài trợ, người cấp phép và các bên thứ ba khác. Chúng tôi muốn lưu ý rằng chúng tôi
            không kiểm soát nội dung hoặc liên kết trên những trang web này và không chịu trách
            nhiệm về các hoạt động được thực hiện trên những trang web được liên kết từ trang web
            của chúng tôi.
          </Typography>
        </Stack>
        <Stack>
          <Typography variant="body2">
            Hơn nữa, các trang web và dịch vụ này, bao gồm cả nội dung và liên kết của chúng, có thể
            thay đổi liên tục. Chúng cũng có thể có chính sách bảo mật và chính sách dịch vụ khách
            hàng riêng của họ. Vì vậy, khi duyệt web và tương tác trên bất kỳ trang web nào khác,
            bao gồm các trang web có liên kết đến trang web của chúng tôi, bạn cần tuân theo các
            điều khoản và chính sách riêng của trang web đó.
          </Typography>
        </Stack>
        <Stack>
          <Typography variant="body2" fontWeight={700}>
            X. THAY ĐỔI CHÍNH SÁCH QUYỀN RIÊNG TƯ NÀY
          </Typography>
          <Typography variant="body2">
            Thỉnh thoảng chúng tôi sẽ cập nhật chính sách quyền riêng tư này. Nếu chúng tôi thực
            hiện bất kỳ thay đổi quan trọng nào, chúng tôi sẽ thông báo cho bạn bằng cách đăng chính
            sách quyền riêng tư được cập nhật trên trang web của chúng tôi hoặc bằng các phương tiện
            khác.
          </Typography>
        </Stack>
        <Stack>
          <Typography variant="body2">
            Việc bạn tiếp tục sử dụng CenterUp sau ngày có hiệu lực của bất kỳ thay đổi nào đối với
            chính sách quyền riêng tư này sẽ cấu thành việc bạn chấp nhận chính sách quyền riêng tư
            được cập nhật.
          </Typography>
        </Stack>
        <Stack>
          <Typography variant="body2" fontWeight={700}>
            XI. BẠN LỰA CHỌN CHÍNH SÁCH VÀ CÁC ĐIỀU KHOẢN
          </Typography>
          <Typography variant="body2">
            Bạn có thể có một số lựa chọn liên quan đến thông tin chúng tôi thu thập về bạn, bao
            gồm:
          </Typography>
          <Stack direction="row" alignItems="start">
            <Iconify icon={APP_ICONS.status.dot} />
            <Typography variant="body2">
              Bạn có thể từ chối thu thập dữ liệu nhất định bằng cách điều chỉnh cài đặt trong thiết
              bị hoặc trình duyệt của mình.
            </Typography>
          </Stack>{' '}
          <Stack direction="row" alignItems="start">
            <Iconify icon={APP_ICONS.status.dot} />
            <Typography variant="body2">
              Bạn có thể yêu cầu chúng tôi xóa thông tin của bạn bằng cách liên hệ với chúng tôi
              theo thông tin bên dưới.
            </Typography>
          </Stack>{' '}
          <Stack direction="row" alignItems="start">
            <Iconify icon={APP_ICONS.status.dot} />
            <Typography variant="body2">
              Trong trường hợp bạn thu hồi các quyền đã cung cấp cho ứng dụng của chúng tôi, các
              tính năng đồng bộ dữ liệu quảng cáo của hệ thống CenterUp mà chúng tôi cung cấp cho
              bạn sẽ hoạt động không chính xác. Vui lòng cân nhắc kĩ trước khi thực hiện, trừ khi
              bạn không còn sử dụng dịch vụ của chúng tôi nữa.
            </Typography>
          </Stack>
        </Stack>
        <Stack>
          <Typography variant="body2" fontWeight={700}>
            XII. LIÊN HỆ CHÚNG TÔI
          </Typography>
          <Typography variant="body2">
            Nếu bạn có bất kỳ câu hỏi hoặc thắc mắc nào về Chính sách bảo mật của chúng tôi. Hãy
            liên hệ ngay đội ngũ của CenterUp để được hỗ trợ ngay nhé!
          </Typography>
          <Stack mt={1}>
            <Stack direction="row" spacing={0.4}>
              <Typography variant="body2">Email:</Typography>
              <Typography variant="body2" fontWeight={700}>
                contact@centerup.vn
              </Typography>
            </Stack>
            <Stack direction="row" spacing={0.4}>
              <Typography variant="body2">Hotline:</Typography>
              <Typography variant="body2" fontWeight={700}>
                0898557169
              </Typography>
            </Stack>{' '}
          </Stack>
        </Stack>
      </Stack>
    </PolicyTabLoyout>
  );
};
